import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

console.log(
  `Feito com carinho por CEN – Coordenação Estratégica de Negócio.\n\nCaso você tenha alguma dúvida ou sugestão a respeito do comportamento do sistema, utilize a sessão "Reportar problema" para nos informar.\n\nObrigado!`
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
